function updateAnchorNode(item, nextState, currentState) {
  var _a;

  if (Array.isArray(item === null || item === void 0 ? void 0 : item.childrens) && !Object.is(item === null || item === void 0 ? void 0 : item.childrens, (_a = currentState === null || currentState === void 0 ? void 0 : currentState[item.id]) === null || _a === void 0 ? void 0 : _a.childrens)) {
    var anchorMap = item.childrens.reduce(function (init, id) {
      var _a, _b;

      var anchor = (_b = (_a = nextState[id]) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.anchor;

      if (typeof anchor === 'number') {
        if (!Array.isArray(init[anchor])) {
          init[anchor] = [];
        }

        init[anchor].push(id);
      }

      return init;
    }, {});
    return Object.assign({}, item, {
      config: Object.assign(Object.assign({}, item.config), {
        anchorMap: anchorMap
      })
    });
  }

  return item;
}

function updateAnchorHandler(partial, nextState, currentState) {
  return Object.keys(partial).reduce(function (init, key) {
    if (key.startsWith('AnchorTabs') || key.startsWith('Conference')) {
      init[key] = updateAnchorNode(partial[key], nextState, currentState);
    } else {
      init[key] = partial[key];
    }

    return init;
  }, {});
}

var updateAnchorWithChange = function updateAnchorWithChange(fn) {
  return function (originSet, get, api) {
    var set = function set(partial, replace) {
      var partialState = typeof partial === 'function' ? partial(get()) : partial;
      var nextState = replace ? partialState : Object.assign({}, get(), partialState);
      originSet(updateAnchorHandler(partialState, nextState, get()), replace);
    };

    api.setState = set;
    var initialState = fn(set, get, api);
    return initialState;
  };
};

export default updateAnchorWithChange;